import ApiService from '@/data/services/ApiService'
import { IPlayerPosition, IServiceResponse } from '@/data/models'
import { AxiosResponse } from 'axios'
import { ICoachType } from '@/data/models/CoachType'

export class CoachTypeApiService extends ApiService {
  static async getAll(): Promise<IServiceResponse<ICoachType[]>> {
    return this.axios.get('coach-types')
      .then((response: AxiosResponse<IServiceResponse<ICoachType[]>>) => response.data)
  }
}
